import { render, staticRenderFns } from "./articleList.vue?vue&type=template&id=9de2e3a0"
import script from "./articleList.vue?vue&type=script&lang=js"
export * from "./articleList.vue?vue&type=script&lang=js"
import style0 from "./articleList.vue?vue&type=style&index=0&id=9de2e3a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonImg: require('/root/workspace/web-wikifxcom_4Lzk/components/common/commonImg.vue').default})
